import $ from 'jquery';
import objectFitImages from 'object-fit-images';
window.jQuery = $;
// window.$ = $;
require('@fancyapps/fancybox');

// $.fancybox.defaults.animationEffect = 'fade';

document.addEventListener('DOMContentLoaded', () => objectFitImages());
